import { render, staticRenderFns } from "./RegisterIntro.vue?vue&type=template&id=c22a6e24&"
import script from "./RegisterIntro.vue?vue&type=script&lang=js&"
export * from "./RegisterIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports